import React, { useState } from 'react';
import Dialog from '@material-ui/core/Dialog';
import Button from '@material-ui/core/Button';
import ListItemText from '@material-ui/core/ListItemText';
import StyledButton from 'components/UI/Button/StyledButton';
import { FontSize, FontWeight } from 'modules/styles/variables';
import {
  MuiRow,
  DialogPopUp,
  SearchPopUpHeader,
  HeaderRow,
  StyledCheckbox,
  OkayDiv,
  StyledMenuItem
} from '../styled';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import Config from 'react-native-config';
import { KeyValue } from 'store/preRegistration/types';

interface RaceSelectionListProps {
  raceList: KeyValue[];
  handleRaceAccept: (selectedRace: string[]) => void;
  patientInfoProps: string[];
}

export function RaceSelectionList(props: RaceSelectionListProps) {
  const racesOnLoad = props.patientInfoProps || ['Unavailable'];
  const [open, setOpen] = React.useState(false);
  const [racesChecked, setRacesChecked] = useState<string[]>(racesOnLoad);
  const ALLOW_UPDATE = Config.PRE_REG_ALLOW_SAVE_PATIENT_DATA === 'enabled';

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleRaceAccept = () => {
    if (racesChecked.length) {
      props.handleRaceAccept(racesChecked);
    }
    setOpen(false);
  };

  const handleCheckBoxClick = (race: KeyValue, notChecked: boolean) => {
    if (notChecked) {
      if (race.key === 'Unavailable' || race.key === 'Patient Declined') {
        setRacesChecked([]);
        setRacesChecked([race.value]);
      } else if (racesChecked.includes('522982749') || racesChecked.includes('522982748')) {
        setRacesChecked([]);
        setRacesChecked([race.value]);
      } else {
        setRacesChecked([...racesChecked, race.value]);
      }
    } else {
      const newArray = racesChecked.filter((value: string) => {
        return race.value !== value;
      });
      setRacesChecked(newArray);
    }
  };

  const unorderedRaces = [...props.raceList];
  const orderedRaces = unorderedRaces.sort((a, b) => (a.key < b.key ? -1 : 1));

  return (
    <>
      <MuiRow data-testid="race-selection-list">
        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogPopUp>
            <HeaderRow>
              <MuiRow>
                <ArrowBackIcon onClick={handleClose} />
                <SearchPopUpHeader fontSize={FontSize.xlarge} fontWeight={FontWeight.bold}>
                  Please select one or more races.
                </SearchPopUpHeader>
              </MuiRow>
            </HeaderRow>
            {orderedRaces.map(race => (
              <StyledMenuItem key={race.key} value={race.key}>
                <StyledCheckbox
                  color="primary"
                  checked={racesChecked.indexOf(race.value) > -1}
                  onClick={evt => {
                    handleCheckBoxClick(race, evt.target.checked);
                  }}
                />
                <ListItemText primary={race.key} />
              </StyledMenuItem>
            ))}
          </DialogPopUp>
          <OkayDiv>
            <StyledButton onClick={handleRaceAccept}>OK</StyledButton>
          </OkayDiv>
        </Dialog>
      </MuiRow>
      {ALLOW_UPDATE ? (
        <Button color="primary" onClick={handleClickOpen}>
          Edit
        </Button>
      ) : null}
    </>
  );
}
